import React from "react";
import Button from "@material-ui/core/Button";
import SvgIcon from "@material-ui/core/SvgIcon";
import { SaveButton, DeleteButton, Toolbar } from "react-admin";
import { withRouter } from "react-router";
import {ReactComponent as TheragunImg} from "./theragun.svg";
import {ReactComponent as PowerdotImg} from "./powerdot.svg";

let CancelButton = props => {
  const { location } = props;
  const basePath = location.pathname.split("/")[1];

  return (
    <Button
      type="submit"
      color="secondary"
      href={`#/${basePath}`}
      style={{
        margin: "10px 24px",
        position: "relative"
      }}
    >
      Cancel
    </Button>
  );
};

CancelButton = withRouter(CancelButton);

export const OkCancelToolbar = props => (
  <Toolbar
    {...props}
    style={{ flex: 1, display: "flex", justifyContent: "start" }}
  >
    <SaveButton redirect="list" submitOnEnter={true} />
    <CancelButton />
    <DeleteButton record={props.record} resource={props.resource} />
  </Toolbar>
);

export const TheragunIcon = () => (
    <SvgIcon>
        <TheragunImg width={24} height={24} />
    </SvgIcon>
)

export const PowerdotIcon = () => (
    <SvgIcon>
        <PowerdotImg width={24} height={24} />
    </SvgIcon>
)
